// extracted by css-extract-rspack-plugin
export default {"horizontal":"h6Ega","vertical":"CY_fu"};